import * as React from "react";
import type {
    IMegaMenuContext,
    IMegaMenuConfig,
    IMegaMenuPersistenceManager,
    IMegaMenuFavorite,
    IMegaMenuData,
    IMegaMenuFavoriteData
} from './definitions';
import type { ILocationMatchProp } from '@@data/entities';
import { buildMegaMenuConfig } from "./helpers";

import "./megamenuroot.less";

export interface IMegaMenuDataContext {
    key: string;
    match: ILocationMatchProp;
    datamgr: IMegaMenuData;
    config: IMegaMenuConfig;
    favorites: IMegaMenuFavoriteData;
    data: any;
    toggleFavorites: (items: IMegaMenuFavorite[]) => void;
}

export const MegaMenuContext = React.createContext<IMegaMenuDataContext>(null);

export interface IMegaMenuDataProps extends IMegaMenuContext {
    className?: string;
    menuKey: string;
    config: IMegaMenuConfig;
    match?: ILocationMatchProp;
    persistence?: IMegaMenuPersistenceManager;
    children?: React.ReactNode;
}

export class MegaMenuData extends React.Component<IMegaMenuDataProps, IMegaMenuDataContext> {
    constructor(props: IMegaMenuDataProps) {
        super(props);

        const favorites = { favorites: [] };
        this.state = {
            key: props.menuKey,
            data: {},
            match: props.match,
            toggleFavorites: (items: IMegaMenuFavorite[]) => this.toggleFavorites(items),
            datamgr: {
                getData: (key: string) => this.getData(key),
                setData: (key: string, data) => this.setData(key, data)
            },
            favorites: favorites,
            config: buildMegaMenuConfig(props, props.config, favorites.favorites)
        };
    }

    getData(key: string) {
        return this.state.data[key];
    }

    setData(key: string, data) {
        this.setState((currentState) => {
            return {
                data: Object.assign({}, currentState.data, { [key]: data })
            };
        });
    }

    componentDidMount() {
    }

    loadFavorites() {
        if (this.props.persistence) {
            this.props.persistence.loadFavorites().then((favs: IMegaMenuFavoriteData) => {
                this.setState({
                    favorites: favs,
                    match: this.props.match,
                    config: buildMegaMenuConfig(this.props, this.props.config, favs?.favorites)
                });
            });
        }
    }

    componentDidUpdate(prevProps: IMegaMenuDataProps) {
        if (prevProps.rights !== this.props.rights
            //|| prevProps.stamp !== this.props.stamp
            || prevProps.config !== this.props.config
            || prevProps.event !== this.props.event
            || prevProps.community !== this.props.community
            || prevProps.customer !== this.props.customer
            || prevProps.menuKey !== this.props.menuKey
            || prevProps.isMobile !== this.props.isMobile
            || prevProps.user.advancedMode !== this.props.user.advancedMode
        ) {
            let favorites = this.state.favorites;
            if (prevProps.config !== this.props.config) {
                favorites = {
                    favorites: []
                };
            }
            
            this.setState({
                key: this.props.menuKey,
                favorites: favorites,
                match: this.props.match,
                config: buildMegaMenuConfig(this.props, this.props.config, favorites?.favorites)
            });
        }


        if (prevProps.persistence !== this.props.persistence) {
            this.loadFavorites();
        }
    }

    toggleFavorites = (items: IMegaMenuFavorite[]) => {
        this.setState((currentState) => {
            const favoriteItems = Array.isArray(currentState.favorites?.favorites) ? [...currentState.favorites.favorites] : [];
            //const favoriteItems = [...currentState.favorites.favorites];
            items.forEach((i) => {
                const existing = favoriteItems.find((it) => it.key == i.key);
                if (existing == null) {
                    favoriteItems.push(i);
                } else {
                    const idx = favoriteItems.indexOf(existing);
                    favoriteItems.splice(idx, 1);
                }
            });

            const favorites = Object.assign({}, currentState.favorites, {
                favorites: favoriteItems
            });
            if (this.props.persistence) {
                this.props.persistence.saveFavorites(favorites);
            }


            return {
                favorites: favorites,
                match: this.props.match,
                config: buildMegaMenuConfig(this.props, this.props.config, favorites.favorites)
            };
        });
    };

    render() {
        return <MegaMenuContext.Provider value={this.state}>
            {this.props.children}
        </MegaMenuContext.Provider>;
    }
}
